module.exports = __webpack_public_path__ + "static/media/quantity-config-placeholder.167025dc.svg";